import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { Homepage1Component } from './pages/homepage1/homepage1.component';
import { Homepage2Component } from './pages/homepage2/homepage2.component';
import { Homepage3Component } from './pages/homepage3/homepage3.component';
import { Homepage4Component } from './pages/homepage4/homepage4.component';
import { AboutComponent } from './pages/about/about.component';
import { AddrestaurantComponent } from './pages/addrestaurant/addrestaurant.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogdetailsComponent } from './pages/blogdetails/blogdetails.component';
import { Blogstyle2Component } from './pages/blogstyle2/blogstyle2.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { ExdealsComponent } from './pages/exdeals/exdeals.component';
import { GeolocatorComponent } from './pages/geolocator/geolocator.component';
import { ListviewComponent } from './pages/listview/listview.component';
import { OrderdetailsComponent } from './pages/orderdetails/orderdetails.component';
import { Restaurantstyle1Component } from './pages/restaurantstyle1/restaurantstyle1.component';
import { Restaurantstyle2Component } from './pages/restaurantstyle2/restaurantstyle2.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { Footer1Component } from './layouts/footer1/footer1.component';
import { Footer2Component } from './layouts/footer2/footer2.component';
import { AdvertisementbannerComponent } from './layouts/advertisementbanner/advertisementbanner.component';
import { BlogleftsidebarComponent } from './layouts/blogleftsidebar/blogleftsidebar.component';
import { BlogrightsidebarComponent } from './layouts/blogrightsidebar/blogrightsidebar.component';
import { RestaurantleftsidebarComponent } from './layouts/restaurantleftsidebar/restaurantleftsidebar.component';
import { RestaurantrightsidebarComponent } from './layouts/restaurantrightsidebar/restaurantrightsidebar.component';
import { LayoutsModule } from './shared/layouts/layouts.module';
import { Advertisementbanner1Component } from './layouts/advertisementbanner1/advertisementbanner1.component';
import { Advertisementbanner2Component } from './layouts/advertisementbanner2/advertisementbanner2.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactComponent } from './pages/contact/contact.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { JwtInterceptor } from '@core/interceptors/jwt.interceptor';
import { TenantInterceptor } from '@core/interceptors/tenant.interceptor';
import { CheckinComponent } from './pages/checkin/checkin.component';
import { QrRedirectComponent } from './pages/qr-redirect/qr-redirect.component';
import { AlertDialogComponent } from './shared/components/alert-dialog/alert-dialog.component';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { ConfirmationModalComponent } from './shared/components/confirmation-modal/confirmation-modal.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { HeroSliderComponent } from './pages/home/components/hero-slider/hero-slider.component';
import { BrowseCategoryComponent } from './pages/home/components/browse-category/browse-category.component';
import { PreviousOrdersComponent } from './pages/home/components/previous-orders/previous-orders.component';
import { ExploreCollectionComponent } from './pages/home/components/explore-collection/explore-collection.component';
import { BannerAdvertisementComponent } from './pages/home/components/banner-advertisement/banner-advertisement.component';
import { PipesModule } from './shared/pipes/pipes.module';
import { metaReducers, reducers } from './store';
import { UserProfileEffects } from './store/user-profile/user-profile.effect';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { AuthEffects } from './store/auth/auth.effects';
import { BusinessEffects } from './store/business/business.effects';
import { AppointmentEffects } from './store/appointment/appointment.effects';
import { SharedModule } from '@shared/shared.module';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    Homepage1Component,
    Homepage2Component,
    Homepage3Component,
    Homepage4Component,
    AboutComponent,
    AddrestaurantComponent,
    BlogComponent,
    BlogdetailsComponent,
    Blogstyle2Component,
    CheckoutComponent,
    ExdealsComponent,
    GeolocatorComponent,
    ListviewComponent,
    OrderdetailsComponent,
    Restaurantstyle1Component,
    Restaurantstyle2Component,
    Footer1Component,
    AdvertisementbannerComponent,
    BlogleftsidebarComponent,
    BlogrightsidebarComponent,
    Advertisementbanner1Component,
    Advertisementbanner2Component,
    ContactComponent,
    ErrorPageComponent,
    CheckinComponent,
    QrRedirectComponent,
    AlertDialogComponent,
    ToastContainerComponent,
    ConfirmationModalComponent,
    NotificationsComponent,
    MainLayoutComponent,
    HeroSliderComponent,
    BrowseCategoryComponent,
    PreviousOrdersComponent,
    ExploreCollectionComponent,
    BannerAdvertisementComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatDialogModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    LayoutsModule,
    SharedModule,
    PipesModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireMessagingModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      UserProfileEffects,
      AuthEffects,
      BusinessEffects,
      AppointmentEffects,
    ]),
    // Store DevTools (only in development)
    !environment.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 25, // Retains last 25 states
          logOnly: environment.production, // Restrict extension to log-only mode
        })
      : [],
  ],
  providers: [
    Location,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
